import moment from 'moment'
import { IFeed } from 'models/IFeed'

const COWVISION_API = 'https://api.cowvision.ru/'
export const FEED_WEIGHT_MOCK_VALUE = 12000

const isFeedWeightMockAllowed = () =>
	process.env.NODE_ENV === 'development' ||
	process.env.REACT_APP_SERVER_NAME === COWVISION_API

export const isFeedWeightMockEnabled = () => {
	if (typeof window === 'undefined' || !isFeedWeightMockAllowed()) return false
	return (
		new URLSearchParams(window.location.search).get('feedWeightMock') === '1'
	)
}

export const applyFeedWeightMock = (plans: IFeed[]): IFeed[] => {
	if (!isFeedWeightMockEnabled()) return plans

	return plans.map(plan => ({
		...plan,
		feed_facts: (plan.feed_facts ?? []).map(fact => ({
			...fact,
			weight: fact.weight || FEED_WEIGHT_MOCK_VALUE,
			has_weight_deviation: true,
			has_deviation: true,
		})),
	}))
}

export const isFeedCorrectMockEnabled = () => {
	if (typeof window === 'undefined' || !isFeedWeightMockAllowed()) return false
	return (
		new URLSearchParams(window.location.search).get('feedCorrectMock') === '1'
	)
}

export const applyFeedCorrectMock = (
	plans: IFeed[],
	date?: Date | null,
): IFeed[] => {
	if (!isFeedCorrectMockEnabled()) return plans

	return plans.map(plan => ({
		...plan,
		feed_facts: (plan.feed_facts ?? []).map(fact => {
			const planTime = (fact.plan_time || plan.time || '00:00').slice(0, 5)
			const [hours, minutes] = planTime.split(':').map(Number)
			const factDt = moment(date || undefined)
				.set({
					hour: Number.isNaN(hours) ? 0 : hours,
					minute: Number.isNaN(minutes) ? 0 : minutes,
					second: 0,
					millisecond: 0,
				})
				.valueOf()

			return {
				...fact,
				fact_dt: factDt,
				has_deviation: false,
				has_weight_deviation: false,
				has_fact_data_demand: false,
				weight: fact.weight ?? fact.plan_weight ?? fact.food_weight ?? null,
			}
		}),
	}))
}
